import { createEntityMutation } from '@packages/api-client';
import { NotificationService } from '@wealthlane/api-services/wealthlane-notification-service';

export const usePostSeenNotification = createEntityMutation<boolean, string>({
  mutationFn: (notificationId) =>
    NotificationService.putApiNotificationApiAppNotificationNotificationSeen(notificationId),
  invalidateKeys: ['getGetUnseenNotificationCountList', 'getGetUnseenNotificationList'],
});
